import { render, staticRenderFns } from "./PracticeRequiredModal.vue?vue&type=template&id=c3ccbeb6&scoped=true&"
import script from "./PracticeRequiredModal.vue?vue&type=script&lang=js&"
export * from "./PracticeRequiredModal.vue?vue&type=script&lang=js&"
import style0 from "./PracticeRequiredModal.vue?vue&type=style&index=0&id=c3ccbeb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3ccbeb6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3ccbeb6')) {
      api.createRecord('c3ccbeb6', component.options)
    } else {
      api.reload('c3ccbeb6', component.options)
    }
    module.hot.accept("./PracticeRequiredModal.vue?vue&type=template&id=c3ccbeb6&scoped=true&", function () {
      api.rerender('c3ccbeb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/Education/PracticeRequiredModal.vue"
export default component.exports